import mapActions from './mapActions';

export default mapActions('my_group_history', {
    fetchAll_url: id => `/api/employees/${id}/my_group_history`
});
